import { jsxs as h, jsx as r } from "react/jsx-runtime";
import { c as p } from "../clsx-OuTLNxxd.js";
import { Icon as m } from "../Icon/Icon.js";
import { c as u } from "../background-bUl5ds8G.js";
const d = "DiscountChip-module_chip__tUmZH",
  l = "DiscountChip-module_with-line-through__qzrdX",
  a = "DiscountChip-module_icon__0zYIT",
  _ = "DiscountChip-module_inverted__7h68p",
  i = {
    chip: d,
    withLineThrough: l,
    icon: a,
    inverted: _
  },
  x = _ref => {
    let {
      children: o,
      className: s,
      background: c,
      lineThrough: n,
      inverted: t = !1
    } = _ref;
    const e = u(c);
    return /* @__PURE__ */h("div", {
      className: p(i.chip, e, s, {
        [i.withLineThrough]: n,
        [i.inverted]: t
      }),
      children: [/* @__PURE__ */r(m, {
        name: "discount-chip",
        size: "1x",
        padding: !1,
        className: i.icon
      }), o]
    });
  };
export { x as DiscountChip };